import { render, staticRenderFns } from "./ConstructionList.vue?vue&type=template&id=5049b8ae&"
import script from "./ConstructionList.vue?vue&type=script&lang=js&"
export * from "./ConstructionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports